import { useState, useEffect, useRef } from 'react';
import styles from './Message.module.css';
import bus from '../../utils/bus';

const DISPLAY_TIME = 5000;

function Message() {
  const [visibility, setVisibility] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('');
  const [progressKey, setProgressKey] = useState(0);

  const messageRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const showMessage = ({ message, type }) => {
      // Cancela o timeout anterior caso exista
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      setVisibility(true);
      setMessage(message);
      setType(type);

      // Reinicia a animação da barra
      setProgressKey((prev) => prev + 1);

      timeoutRef.current = setTimeout(() => {
        setVisibility(false);
      }, DISPLAY_TIME);
    };

    bus.addListener('flash', showMessage);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      bus.removeListener('flash', showMessage);
    };
  }, []);

  useEffect(() => {
    if (visibility && messageRef.current) {
      messageRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [visibility]);

  return (
    visibility && (
      <div
        ref={messageRef}
        className={`${styles.message} ${styles[type]}`}
      >
        <span>{message}</span>

        <div className={styles.progressContainer}>
          <div
            key={progressKey}
            className={styles.progress}
          ></div>
        </div>
      </div>
    )
  );
}

export default Message;